import { UPDATE_PAYMENT_STATUS } from "../../../middleware/paymentSignalRMiddleware";
import invitations from "../../../shared/invitations";
import { CHECK_DISCOUNT_CODE, CLEAR_PAYMENT, CLEAR_PAYMENT_REDIRECT, CREATE_PAYMENT_INTENT, CREATE_PAYMENT_SESSION, FETCH_PRICING_PLANS, PAYMENT_GET_FULL_TOKEN, PAYMENT_ERROR, PAYMENT_GET_CURRENCIES, PAYMENT_PAID, PAYMENT_PAYING, SET_PAYMENT_PAID_FOR_FREE_PRICING_PLAN, SET_PAYMENT_PENDING } from "./actions";

interface RegisterState {
  loadingPricingPlans: boolean;
  loadingCurrencies: boolean;
  paying: boolean;
  user: any;
  currencies: any[];
  pricingPlans: any[];
  selectedCurrencyId: any;
  selectedPricingPlan: any;
  userCountryCode: any;
  noPaymentNeeded: boolean;
  pendingSetupIntent: boolean;
  checkingCode: boolean;
  discountCodeValid: boolean | null;
  discountCodeDescription: string | null,
  firstMonthPrice: number | null;
  hasTax: boolean;
  sessionId: string | null;
  paymentComplete: boolean;
  paid: boolean;
}

const defaultState: RegisterState = {
  loadingPricingPlans: false,
  loadingCurrencies: false,
  paying: false,
  user: {},
  currencies: [],
  selectedCurrencyId: null,
  pricingPlans: [],
  selectedPricingPlan: null,
  userCountryCode: null,
  noPaymentNeeded: false,
  pendingSetupIntent: false,
  checkingCode: false,
  discountCodeValid: null,
  discountCodeDescription: null,
  firstMonthPrice: null,
  hasTax: false,
  sessionId: null,
  paymentComplete: false,
  paid: false
};

const reducer = (state = defaultState, action: any = {}) => {
  switch (action.type) {

    case FETCH_PRICING_PLANS + "_PENDING": {
      return {
        ...state,
        errors: null,
        loadingPricingPlans: true,
        discountCodeDescription: null
      };
    }

    case FETCH_PRICING_PLANS + "_FULFILLED": {
      return {
        ...state,
        pricingPlans: action.payload.data.pricingPlans,
        currencies: action.payload.data.billingCurrencies,
        selectedCurrencyId: action.payload.data.userBillingCurrencyId,
        selectedPricingPlan: action.payload.data.pricingPlan,
        userCountryCode: action.payload.data.userCountryCode,
        hasTax: action.payload.data.hasTax,
        loadingPricingPlans: false
      };
    }

    case FETCH_PRICING_PLANS + "_REJECTED": {
      return {
        ...state,
        errors: action.payload.response.data.errors,
        loadingPricingPlans: false
      };
    }

    case CHECK_DISCOUNT_CODE + "_PENDING": {
      return {
        ...state,
        errors: null,
        checkingCode: true
      };
    }

    case CHECK_DISCOUNT_CODE + "_FULFILLED": {
      return {
        ...state,
        discountCodeValid: action.payload.data.valid,
        discountCodeDescription: action.payload.data.description,
        firstMonthPrice: action.payload.data.firstMonthPrice,
        checkingCode: false
      };
    }

    case CHECK_DISCOUNT_CODE + "_REJECTED": {
      return {
        ...state,
        errors: action.payload?.response?.data?.errors ?? { "": [action.payload.toString()] },
        checkingCode: false
      };
    }

    case PAYMENT_GET_CURRENCIES + "_PENDING": {
      return {
        ...state,
        loadingCurrencies: true
      };
    }

    case PAYMENT_GET_CURRENCIES + "_FULFILLED": {
      return {
        ...state,
        currencies: action.payload.data.currencies,
        user: { ...state.user, currencyId: action.payload.data.defaultId },
        defaultCurrencyId: action.payload.data.defaultId,
        loadingCurrencies: false
      };
    }

    case PAYMENT_GET_CURRENCIES + "_REJECTED": {
      return {
        ...state,
        errors: action.payload.response.data.errors,
        loadingCurrencies: false
      };
    }

    case CREATE_PAYMENT_INTENT + "_PENDING": {
      return {
        ...state,
        errors: null,
        paying: true
      };
    }

    case CREATE_PAYMENT_INTENT + "_FULFILLED": {
      return {
        ...state,
        clientSecret: action.payload.data.clientSecret,
        noPaymentNeeded: action.payload.data.clientSecret === null,
        pendingSetupIntent: action.payload.data.pendingSetupIntent
      };
    }

    case CREATE_PAYMENT_INTENT + "_REJECTED": {
      return {
        ...state,
        errors: action.payload.response.data.errors,
        paying: false
      };
    }

    case CREATE_PAYMENT_SESSION + "_PENDING": {
      return {
        ...state,
        errors: null,
        paying: true
      };
    }

    case CREATE_PAYMENT_SESSION + "_FULFILLED": {
      return {
        ...state,
        sessionId: action.payload.data.sessionId
      };
    }

    case CREATE_PAYMENT_SESSION + "_REJECTED": {
      debugger;
      return {
        ...state,
        errors: action.payload.response.data.errors,
        paying: false
      };
    }

    case SET_PAYMENT_PENDING + "_PENDING": {
      return {
        ...state,
        errors: null
      };
    }

    case SET_PAYMENT_PENDING + "_FULFILLED": {

      return {
        ...state,
        paymentComplete: action.payload.data.paymentComplete
      };
    }

    case SET_PAYMENT_PENDING + "_REJECTED": {
      debugger;
      return {
        ...state,
        errors: action.payload?.response?.data?.errors
      };
    }

    case SET_PAYMENT_PENDING + "_PENDING": {
      return {
        ...state,
        errors: null
      };
    }

    case SET_PAYMENT_PAID_FOR_FREE_PRICING_PLAN + "_FULFILLED": {
      return {
        ...state,
        paymentComplete: true,
        // paymentStatus: action.meta.paymentStatus,
        // paymentStatusDescription: action.meta.paymentStatusDescription,
        noPaymentNeeded: true
      };
    }

    case SET_PAYMENT_PAID_FOR_FREE_PRICING_PLAN + "_REJECTED": {
      debugger;
      return {
        ...state,
        errors: action.payload?.response?.data?.errors ?? action.payload
      };
    }

    case PAYMENT_GET_FULL_TOKEN + "_PENDING": {
      return {
        ...state,
        errors: null
      };
    }

    case PAYMENT_GET_FULL_TOKEN + "_FULFILLED": {
      return {
        ...state,
        // set token

        paid: true
      };
    }

    case PAYMENT_GET_FULL_TOKEN + "_REJECTED": {
      return {
        ...state,
        errors: action.payload.response.data.errors
      };
    }

    case CLEAR_PAYMENT_REDIRECT: {
      return {
        ...state,
        redirect: null
      };
    }

    case CLEAR_PAYMENT: {
      debugger;
      return {
        ...state,
        registered: false
      };
    }

    case PAYMENT_ERROR: {
      return {
        ...state,
        errors: { errorMessage: [action.payload] }
      };
    }

    case PAYMENT_PAYING: {
      return {
        ...state,
        paying: action.payload
      };
    }

    case PAYMENT_PAID: {
      return {
        ...state,
        paid: true
      };
    }

    case UPDATE_PAYMENT_STATUS: {
      return {
        ...state,
        paymentComplete: action.meta.paymentStatus === 100
      };
    }

    default:
      return state;
  }
};

export default reducer;
